/**
 * SAFICのドメイン
 */
export const DOMAIN_SAFIC = 'sompo-direct.ra-abas.jp'

/**
 * SJのドメイン
 */
export const DOMAIN_SJ = 'sompo-japan.ra-abas.jp'

/**
 * ZNのドメイン
 */
export const DOMAIN_ZN = 'zenjikyo.ra-abas.jp'

/**
 * NKRのドメイン
 */
export const DOMAIN_NKR = 'nikkaren.ra-abas.jp'

export default {
  SAFIC: DOMAIN_SAFIC,
  SJ: DOMAIN_SJ,
  ZN: DOMAIN_ZN,
  NKR: DOMAIN_NKR,
}
